import { JobSchemaInputs, JobOutcomeInputValues } from '../../models/job-schema.js';

export function coerceOutcomeInputs(
  outcomeInputs: JobSchemaInputs | undefined,
  suppliedInputs?: JobOutcomeInputValues,
): JobOutcomeInputValues {
  return Object.keys(outcomeInputs || {}).reduce((out: JobOutcomeInputValues, inputKey) => {
    const input = outcomeInputs && outcomeInputs[inputKey];
    const supplied = suppliedInputs?.[inputKey];
    const isSupplied = supplied !== undefined && supplied !== null && supplied !== '';
    if (input?.optional && !input.value && !isSupplied) return out;
    if (!input || (!input.value && !isSupplied)) throw new Error(`Missing input value for ${inputKey}`);

    let value: JobOutcomeInputValues[string] | undefined = isSupplied ? supplied : input.value;

    if (value !== null && value !== undefined) {
      if (input.type === 'boolean') {
        if (typeof value === 'string') {
          value = value === 'true';
        } else if (typeof value === 'boolean') {
          value = value === true;
        } else if (typeof value === 'number') {
          value = value === 1;
        }
      } else if (input.type === 'number') {
        value = Number(value);
      } else if (input.type === 'string') {
        value = value.toString();
      } else if (input.type === 'array') {
        if (!Array.isArray(value)) throw new Error(`Input ${inputKey} must be an array`);
      } else if (input.type === 'object') {
        if (typeof value !== 'object' || Array.isArray(value)) throw new Error(`Input ${inputKey} must be an object`);
      } else {
        throw new Error(`Unknown input type ${input.type}`);
      }
    }

    if (value !== undefined) {
      out[inputKey] = value;
    }

    return out;
  }, {});
}
